/**
 * Optimise les URLs d'images en passant par le CDN wsrv.nl
 * - Redimensionne à la largeur demandée
 * - Convertit en WebP (30-50% plus léger que PNG/JPG)
 * - Quality optimisée
 * - Cache CDN agressif (1 an)
 *
 * Utilisation :
 *   <img src={optimizeImage(product.image, 600)} />
 */
export const optimizeImage = (url, width = 800, quality = 82) => {
  if (!url) return url;

  // Ne pas optimiser les data: URIs ni les SVG
  if (url.startsWith("data:") || url.endsWith(".svg")) return url;

  // wsrv.nl accepte n'importe quel host public — on enlève juste le https://
  const cleanUrl = url.replace(/^https?:\/\//, "");
  return `https://wsrv.nl/?url=${encodeURIComponent(cleanUrl)}&w=${width}&output=webp&q=${quality}&we`;
};

/**
 * Génère un srcset responsive pour <img>
 * Permet au navigateur de choisir la bonne taille selon l'écran (gain mobile).
 */
export const optimizeImageSrcSet = (url, widths = [320, 640, 960, 1280], quality = 82) => {
  if (!url || url.startsWith("data:") || url.endsWith(".svg")) return undefined;
  return widths
    .map((w) => `${optimizeImage(url, w, quality)} ${w}w`)
    .join(", ");
};
